import React, { useState } from 'react';
import { Camera, Zap, TrendingUp } from 'lucide-react';
import ImageUploadModal from './ImageUploadModal';

export default function ContributeToVPRButton({ coordinates, propertyUrl }) {
    const [showUploadModal, setShowUploadModal] = useState(false);

    if (!coordinates) return null;

    return (
        <>
            {/* CTA Card */}
            <div className="bg-gradient-to-br from-emerald-50 to-green-50 border-2 border-emerald-200 rounded-2xl p-6 shadow-sm hover:shadow-md transition-shadow">
                <div className="flex items-start justify-between gap-4">
                    <div className="flex-1">
                        <div className="flex items-center gap-2 mb-2">
                            <div className="p-2 bg-emerald-100 rounded-lg">
                                <Camera className="w-5 h-5 text-emerald-600" />
                            </div>
                            <h3 className="text-lg font-bold text-gray-900">Help Improve Accuracy</h3>
                        </div>
                        <p className="text-gray-700 text-sm mb-4">
                            Contribute property images to our VPR database and earn ProprPoints!
                            Your images help us achieve <span className="font-semibold text-emerald-700">street-level precision</span>.
                        </p>

                        {/* Benefits Grid */}
                        <div className="grid grid-cols-2 gap-3 mb-4">
                            <div className="flex items-center gap-2 text-sm">
                                <Zap className="w-4 h-4 text-emerald-600" />
                                <span className="text-gray-700"><span className="font-semibold">50+ points</span> per image</span>
                            </div>
                            <div className="flex items-center gap-2 text-sm">
                                <TrendingUp className="w-4 h-4 text-emerald-600" />
                                <span className="text-gray-700">Earn <span className="font-semibold">badges</span> & climb tiers</span>
                            </div>
                        </div>

                        <button
                            onClick={() => setShowUploadModal(true)}
                            className="w-full sm:w-auto px-6 py-3 bg-emerald-600 text-white font-semibold rounded-lg hover:bg-emerald-700 transition-colors shadow-md hover:shadow-lg flex items-center justify-center gap-2"
                        >
                            <Camera className="w-5 h-5" />
                            Contribute Images
                        </button>
                    </div>

                    {/* Visual Element */}
                    <div className="hidden sm:block">
                        <div className="w-24 h-24 bg-emerald-100 rounded-2xl flex items-center justify-center">
                            <Camera className="w-12 h-12 text-emerald-600" />
                        </div>
                    </div>
                </div>
            </div>

            {/* Upload Modal */}
            <ImageUploadModal
                isOpen={showUploadModal}
                onClose={() => setShowUploadModal(false)}
                initialCoordinates={coordinates}
                propertyUrl={propertyUrl}
            />
        </>
    );
}
